import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Link, Stack, Typography } from "@mui/material"


const LessonAnswerDialog = ({ open, onClose, data }) => {

    if (!data) return null

    return <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
        <DialogTitle>
            Задание для {data?.student_name}
        </DialogTitle>
        <DialogContent>
            <Stack direction="column" spacing={1}>

                <Typography variant="h6">{data?.task?.name}</Typography>
                <Typography textAlign="justify">{data?.task?.task_text}</Typography>
                <Divider />

                {data?.task?.answer_text && <>
                    <Typography variant="h6">Ответ</Typography>
                    <Typography textAlign="justify">{data?.task?.answer_text}</Typography>
                    <Divider />
                </>}

                {data?.task?.files?.length > 0 && <>
                    <Typography variant="h6">Прикрепленные файлы</Typography>
                    <Divider />
                    <Stack direction="column">
                        {data?.task?.files?.map(file => <Link key={file.id} href={file.link}>{file.name}</Link>)}
                    </Stack>
                </>}
                
            </Stack>
        </DialogContent>
        <DialogActions>
            <Button color="error" onClick={onClose}>
                Закрыть
            </Button>
        </DialogActions>
    </Dialog>
}

export default LessonAnswerDialog